import React, { useState, useCallback, useContext } from 'react';

const INITIAL_STATE = {
  section: "department-info",
  customSections: [],
  marketingSections: [],
  recruitmentName: "Recruitment",
  disabledSort: false,
  previewSection: false,
  disableWelcomeOption: false,
  disableRecruitmentOption: false,
  customSectionsSaving: [],
  disableGalleryOption: false,
  disableDonateOption: false,
  disableResourcesOption: false,
  lastCustomSectionId: '',
  newSectionSaving: [],
  galleryName: "Gallery",
  donateName: "Donate",
};

const MenuSectionContext = React.createContext(INITIAL_STATE);

function MenuSectionProvider({ children }) {
  const [state, setState] = useState(INITIAL_STATE);

  const setSection = useCallback(
    (newValue = true) => {
      setState(state => (
        {
          ...state,
          section: newValue
        }))
    },
    [],
  )
  const setCustomSections = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          customSections: newValue
        }))
    },
    [],
  )

  const setMenuMarketingSections = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          marketingSections: newValue
        }))
    },
    [],
  )

  const setCustomSectionSaving = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          customSectionsSaving: newValue
        }))
    },
    [],
  )

  const setPreviewSection = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          previewSection: newValue
        }))
    },
    [],
  )

  const setDisableWelcomeOption = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disableWelcomeOption: newValue
        }))
    },
    [],
  )

  const setDisableRecruitmentOption = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disableRecruitmentOption: newValue
        }))
    },
    [],
  )

  const setDisabledSort = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disabledSort: newValue
        }))
    },
    [],
  )

  const setRecruitmentName = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          recruitmentName: newValue
        }))
    },
    [],
  )

  const setDisableGalleryOption = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disableGalleryOption: newValue
        }))
    },
    [],
  )

  const setDisableDonateOption = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disableDonateOption: newValue
        }))
    },
    [],
  )

  const setLastCustomSectionId = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          lastCustomSectionId: newValue
        }))
    },
    [],
  )

  const setNewSectionSaving = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          newSectionSaving: newValue
        }))
    },
    [],
  )

  const setGalleryName = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          galleryName: newValue.length > 0 ? newValue : 'Gallery'
        }))
    },
    [],
  )

  const setDonateName = useCallback(
    (newValue = []) => {
      setState(state => (
        {
          ...state,
          donateName: newValue.length > 0 ? newValue : 'Donate'
        }))
    },
    [],
  )

  const setDisableResourcesOption = useCallback(
    (newValue) => {
      setState(state => (
        {
          ...state,
          disableResourcesOption: newValue
        }))
    },
    [],
  )

  return <MenuSectionContext.Provider value={{
    state, actions: {
      setSection,
      setDisabledSort,
      setPreviewSection,
      setCustomSections,
      setMenuMarketingSections,
      setRecruitmentName,
      setCustomSectionSaving,
      setDisableWelcomeOption,
      setDisableRecruitmentOption,
      setDisableGalleryOption,
      setDisableDonateOption,
      setLastCustomSectionId,
      setNewSectionSaving,
      setGalleryName,
      setDonateName,
      setDisableResourcesOption
    }
  }}>{children}</MenuSectionContext.Provider>;
}

export function useMenuSectionContext() {
  const { state, actions } = useContext(MenuSectionContext);
  return { state, actions }
}

export default MenuSectionProvider;
